import { render } from "./PRegister.vue?vue&type=template&id=1dd7e029&scoped=true"
import script from "./PRegister.vue?vue&type=script&lang=js"
export * from "./PRegister.vue?vue&type=script&lang=js"

import "./PRegister.vue?vue&type=style&index=0&id=1dd7e029&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dd7e029"]])

export default __exports__